import React, { useEffect, useState } from "react";
import "./Cards.css";

import Card from "../Card/Card";

const Cards = ({ view = "overview", data = null, setSelectedTab = null }) => {

    const [cardsData, setCardsData] = useState(null);

    const makeCardData = ({
        title,
        barValue,
        value,
    }) => {
        return {
            title: title,
            barValue: barValue,
            value: value,
            png: "",
        };
    };

    useEffect(() => {
        (async () => {

            const questionsData = (data && data.questionData) ?
                makeCardData({
                    title: "Questions",
                    barValue: data.questionData.question_accuracy,
                    valueTitle: "Total Number of Questions Attempted",
                    value: data.questionData.num_questions,
                }) : makeCardData({
                    title: "Questions",
                    barValue: 0.0,
                    valueTitle: "Total Number of Questions Attempted",
                    value: 354,
                })

            const lecturesData = (data && data.lectureData) ?
                makeCardData({
                    title: "Lectures",
                    barValue: data.lectureData.lecture_revision_rate,
                    valueTitle: "Total Number of Lectures Given",
                    value: data.lectureData.num_lectures,
                }) : makeCardData({
                    title: "Lectures",
                    barValue: 0.0,
                    valueTitle: "Total Number of Questions Attempted",
                    value: 50,
                })

            const testsData = await (data && data.testsData) ?
                makeCardData({
                    title: "Tests",
                    barValue: data.testsData.test_accuracy,
                    valueTitle: "Total Number of Tests Taken",
                    value: data.testsData.num_tests,
                }) : makeCardData({
                    title: "Tests",
                    barValue: 0.0,
                    valueTitle: "Total Number of Questions Attempted",
                    value: 6,
                })

            // const doubtsData = data.lecture_stats[0].total_batch_lectures ?
            //     makeCardData({
            //         title: "Lectures",
            //         barValue: data.lecture_stats[0].total_video_watches / data.lecture_stats[0].total_batch_lectures,
            //         value: data.lecture_stats[0].total_attended,
            //     }) : makeCardData({
            //         title: "Lectures",
            //         barValue: 0,
            //         value: 0,
            //     })

            if (view === "overview") setCardsData([questionsData, lecturesData, testsData]);
        })();
    }, [data])

    return (
        <div className="Cards flex">

            {cardsData && cardsData.map((card, id) => {
                return (
                    <div className="cardContainer" key={id}>

                        <Card
                            title={card.title}
                            color={card.color}
                            barValue={card.barValue}
                            valueTitle={card.valueTitle}
                            value={card.value}
                            png={card.png}
                            series={card.series}
                            // selectedTab={selectedTab}
                            setSelectedTab={setSelectedTab}
                        />

                    </div>
                );
            })}
        </div>
    );
};

export default Cards;